export default __webpack_public_path__ + "static/media/BannerFinal.a9bf31aa.png";